import { Tabs, Divider } from 'antd';
import constants from '../../constants/constants';
import { SettingOutlined, CarryOutOutlined, ProfileOutlined } from '@ant-design/icons';
import SocialMediaPromo from '../SocialMediaPromo';
import SocialMediaConfigure from './SocialMediaConfigure';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { useContext, useEffect } from 'react';
import { CommonContext } from '../../Context';
// import SocialReports from './SocialReports';
const { TabPane } = Tabs;

const SocialMediaContainer = () => {

  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  
  useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);

	//Render
	return (
		<div>
      <div className='uppercase font-bold text-xl'>Social Media</div>
			<Divider className='my-3'/>
			<Tabs defaultActiveKey="1">
			<TabPane
        tab={ <span className='uppercase'><SettingOutlined className='text-xl' />{constants.SocialMediaTab1}</span> }
        key={1}
      >
        <SocialMediaConfigure/>
      </TabPane>
      <TabPane
        tab={ <span className='uppercase'><CarryOutOutlined className='text-xl' />{constants.SocialMediaTab2}</span> }
        key={2}
      >
        <SocialMediaPromo isSelfService="t"/>
      </TabPane>
      {/* <TabPane
        tab={<span className='uppercase'><CarryOutOutlined className='text-xl' />{constants.SocialTab2}</span>}
        key={3}
      >
        <SocialReports />
      </TabPane> */}
			</Tabs>
		</div>
	);
};

export default SocialMediaContainer;